import { useSelector } from 'react-redux';
import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

export default function useLoggedInStatus(): { isLoggedIn: boolean | null } {
  return {
    isLoggedIn: useSelector<ImmutableRootState<boolean | null>, boolean | null>(
      (state) => state.getIn(['login', 'loggedIn'], null),
    ),
  };
}
